import { createHashRouter, Navigate } from 'react-router-dom';
import App from '@/App';
import InboxPage from '@/pages/InboxPage';
import ChatboxPage from '@/pages/ChatboxPage';

export const router = createHashRouter([
  {
    path: '/',
    element: <App />,
    children: [
      {
        path: '/',
        element: <Navigate to="/inbox" />,
      },
      {
        path: '/inbox',
        element: <InboxPage />,
      },
      {
        path: '/chatbox',
        element: <ChatboxPage />,
      },
    ],
  },
]);
